import { gql } from '@apollo/client';

export const COUNT_PAGE_VIEW_MUTATION = gql`
  mutation CountPageViewMutation($id: Int!) {
    incrementPostViewCount(id: $id) {
      id
      count
    }
  }
`;

export interface CountPageViewMutationVars {
  id: number;
}

export interface CountPageViewMutationResponse {
  incrementPostViewCount: {
    id: number;
    count: number;
  };
}
